export const nearZeroQuantityEpsilon = 1e-9

export function normalizeNearZeroQuantity(value: number) {
  return Math.abs(value) <= nearZeroQuantityEpsilon ? 0 : value
}

export function hasPositiveReconciliationDiscrepancy(
  damagedQty: number,
  rejectedQty: number,
) {
  return (
    normalizeNearZeroQuantity(damagedQty) > 0 ||
    normalizeNearZeroQuantity(rejectedQty) > 0
  )
}
